import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Output() logedout: EventEmitter<string> = new EventEmitter<string>();
  @Output() rightSidebarChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  canAccess = false;
  sidebarNavigation: {
    routeLink: string;
    routeName: string;
    icon: string;
  }[];

  ngOnInit(): void {
    this.sidebarNavigation = [
      {
        routeLink: '/dashboard',
        routeName: 'Dashboard',
        icon: 'dashboard'
      },
      {
        routeLink: '/policy',
        routeName: 'Policy',
        icon: 'policy'
      },
      {
        routeLink: '/payments',
        routeName: 'Payments',
        icon: 'paid'
      },
      {
        routeLink: '/claims',
        routeName: 'Claims',
        icon: 'description'
      },
      {
        routeLink: 'profile/info',
        routeName: 'keywords.account_settings',
        icon: 'person'
      },
      {
        routeLink: 'logout',
        routeName: 'keywords.logout',
        icon: 'person'
      }
    ];
  }

  actionClicked(routeName: string) {
    this.rightSidebarChange.emit(false);
    if (routeName === 'logout') this.logout();
  }

  logout() {
    this.logedout.emit();
  }
}
